import axiosUtil from "../utils/axiosUtil"
import { PER_PAGE } from "../components/variables/variables"

const sectionsApi = {
    getSections: async ({ perPage, page }) => {
        try {
            const result = await axiosUtil.get('/sections', {
                perPage: (!perPage || perPage <= 0) ? PER_PAGE : perPage,
                page: (!page || page <= 0) ? 1 : page,
            })
            return result;
        } catch (error) {
            console.error(error);
        }
    },
    getSectionsForDashboard: async () => {
        try {
            return await axiosUtil.get('/sections/dashboard')
        } catch (error) {
            console.error(error);
        }
    },
    getSectionsByServiceType: async ({ perPage, page, serviceType, status, tripId }) => {
        try {
            const result = await axiosUtil.get('/sections/serviceType', {
                serviceType,
                status,
                perPage: (!perPage || perPage <= 0) ? PER_PAGE : perPage,
                page: (!page || page <= 0) ? 1 : page,
                tripId: tripId || ''
            })
            return result?.data;
        } catch (error) {
            console.error(error);
        }
    },
}

export default sectionsApi;
